module.exports = __webpack_public_path__ + "img/txm.2cccb7e9.svg";